/** Lesson completion grade — bronze (many tries) → silver → gold (first try). */
export type Grade = 'gold' | 'silver' | 'bronze';

export function gradeRank(grade: Grade): number {
  switch (grade) {
    case 'gold':
      return 3;
    case 'silver':
      return 2;
    case 'bronze':
      return 1;
  }
}

export function betterGrade(a: Grade, b: Grade): Grade {
  return gradeRank(a) >= gradeRank(b) ? a : b;
}
